import { LatLngBounds } from "@agm/core";
import { Component } from "@angular/core";
import nomadLocationsList from "../../../assets/nomadLocationsList.json";
import nomadMapStyles from "../../../assets/nomadMapStyles.json";

@Component({
  selector: "app-nomad",
  styleUrls: ["./nomad.view.component.scss"],
  templateUrl: "./nomad.view.component.html",
})
export class NomadComponent {
  private zoom = 8;
  private lat = 0;
  private lng = 0;
  private markers: IMarker[] = [];
  private mapStyles = nomadMapStyles;

  private getCityGeolocation(cities: string[]) {
    const geocoder = new google.maps.Geocoder();

    const x = [];
    cities.forEach((c, i) => {

      if (i > 10) {
        return;
      }

      geocoder.geocode({ address: c }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          const { formatted_address, geometry } = results[0];

          x.push({
            name: c,
            coordinates: {
              lat: geometry.location.lat(),
              lng: geometry.location.lng(),
            },
          });
          console.log(JSON.stringify(x));

        } else {
          alert("Geocode was not successful for the following reason: " + status);
        }
      });
    });
  }

  private clickedMarker(label: string, index: number) {
    console.log(`clicked the marker: ${label || index}`);
  }

  private loadMarkers(map) {
    // Use this function to add new locations to the map
    // const x = ["Buenos Aires, Argentina"];
    // setTimeout(() => { this.getCityGeolocation(x); }, 2000);

    const { locations } = nomadLocationsList;
    const bounds = new google.maps.LatLngBounds();

    let citiesCount = 0;

    locations.forEach((location) => {

      location.cities.forEach((c) => {
        citiesCount++;
        const { lat, lng } = c.coordinates;

        this.markers.push({
          label: `${c.name}, ${location.country}`,
          lat,
          lng,
        });

        bounds.extend(new google.maps.LatLng(lat, lng));
      });
    });

    map.fitBounds(bounds);
  }
}

// just an interface for type safety.
interface IMarker {
  lat: number;
  lng: number;
  label?: string;
  draggable?: boolean;
}



// WEBPACK FOOTER //
// ./src/app/views/nomad/nomad.view.component.ts